<template>
  <section class="project-select-container">
    <base-svg-icon
      icon-class="icon-address"
      class-name="icon-address"
    />
    <el-cascader
      ref="projectSelectRef"
      v-model="selectCurrent"
      :options="orgList"
      :props="selectProps"
      filterable
      :popper-append-to-body="false"
      placeholder="请选择组织"
      :disabled="disabled"
      @change="handleChangeOrg"
    />
  </section>
</template>
<script setup lang="ts">
  import {
    computed, ref, watch, nextTick,
  } from 'vue';
  import { CascaderProps } from 'element-plus';
  import { useAppStore } from '@/store/app';
  import { useOrgStore } from '@/store/org';

  defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const appStore = useAppStore();
  const orgStore = useOrgStore();
  const projectSelectRef = ref();
  const selectCurrent = ref<string[]>([]);
  const orgList = computed(() => orgStore.orgList);

  const selectProps = computed((): CascaderProps => ({
    checkStrictly: !orgStore.projectCheckStrictly,
    label: 'name',
    value: 'orgId',
    expandTrigger: 'hover',
  }));
  const handleChangeOrg = () => {
    const checkedNodes = projectSelectRef.value.getCheckedNodes()[0];
    console.log('checkedNodes-single', checkedNodes);
    if (checkedNodes && checkedNodes.data) {
      orgStore.setCurrentOrgInfo(checkedNodes.data, true);
      orgStore.setCurrentOrgInfoList([checkedNodes.data], true);
    }
    nextTick(() => {
      projectSelectRef.value.togglePopperVisible(false);
    });
  };

  watch(
    () => orgStore.currentOrgInfo,
    (newVal) => {
      if (newVal) {
        selectCurrent.value = newVal.idPath ? newVal.idPath.split('|') : [];
      }
    },
    {
      immediate: true,
      deep: true,
    }
  );
</script>
<style scoped lang="scss">
.project-select-container {
  position: relative;

  .icon-address {
    position: absolute;
    top: 5px;
    left: 6px;
    z-index: 9;
    font-size: 18px;
  }
}

.label {
  margin-right: 6px;
  font-size: 12px;
}

:deep(.#{$namespace}-cascader) {
  width: 160px;

  .#{$namespace}-input__wrapper {
    padding-left: 28px;
  }
}

:deep(.ma-cascader){
  width: 260px;
}

</style>
